/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { DataExportDtoFromJSON, DataExportDtoToJSON, } from './DataExportDto';
/**
 * Check if a given object implements the DataExportStateResponse interface.
 */
export function instanceOfDataExportStateResponse(value) {
    let isInstance = true;
    return isInstance;
}
export function DataExportStateResponseFromJSON(json) {
    return DataExportStateResponseFromJSONTyped(json, false);
}
export function DataExportStateResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'latest': !exists(json, 'latest') ? undefined : DataExportDtoFromJSON(json['latest']),
        'nextRequestAt': !exists(json, 'nextRequestAt') ? undefined : (json['nextRequestAt'] === null ? null : new Date(json['nextRequestAt'])),
    };
}
export function DataExportStateResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'latest': DataExportDtoToJSON(value.latest),
        'nextRequestAt': value.nextRequestAt === undefined ? undefined : (value.nextRequestAt === null ? null : value.nextRequestAt.toISOString()),
    };
}
